/**
 * SurroundingCheckbox
 * 
 * @Author: Focci
 * @Date: 2023-12-10 16:36:49
 * @Last Modified by: Focci
 * @Last Modified time: 2023-12-10 16:36:49
 */

import StyledCheckbox from '@comp/form/StyledCheckbox'
import useStorage from '@hook/useStorage'
import { isAU } from '@lib/utils'
import { useTranslations } from 'next-intl'
import { useCallback, useState } from 'react'

function SurroundingCheckbox(props) {
  const th = useTranslations('home')

  return (
    <StyledCheckbox
      label={th('surroundingSurub')}
      {...props}
    />
  )
}

export default function useSurroundingCheckbox() {
  const { setItem, getItem } = useStorage('HG_SURROUNDING_CHECKBOX', true)
  const checkedValue = getItem()
  
  // [Sam] 2024-11-29 15:43 搜索页面用列表+地图展示，搜索的城区默认打开“周边搜索” 只是澳洲
  const [surrounding, setSurrounding] = useState(checkedValue === null ? isAU : !!checkedValue)

  const handleCheckboxChange = useCallback((e) => {
    setSurrounding(e.target.checked)
    setItem(e.target.checked)
  }, [setItem])

  return {
    surrounding,
    SurroundingCheckbox,
    handleCheckboxChange,
  }
}
